import { calculateAge } from '../survey/calcSurveyDerivatives';
import { zipCodeToState } from '../../zipCodeToState';
import { isTobacco } from '@shared';

const MARITAL_STATUS_MAPPING: Record<string, string> = {
  'Never married': 'Single',
  'Married': 'Married',
  'Married, spouse absent': 'Married',
  'Partnered': 'Married',
  'Separated': 'Single',
  'Divorced': 'Single',
  'Widowed': 'Single',
  "I don't know / prefer not to answer": 'Single',
};

export function mapMaritalStatusToTraditionalLTC(maritalStatus?: string): string {
  if (!maritalStatus) return 'Single';

  return MARITAL_STATUS_MAPPING[maritalStatus] || 'Single';
}

export function clientHasPartnerWithDemographics(
  client?: { partnerClientId?: string | null } | null,
  partner?: { intakeSurvey?: Partial<IntakeSurvey> | null } | null,
): boolean {
  return Boolean(
    client?.partnerClientId &&
      partner?.intakeSurvey?.clientBirthDate &&
      partner?.intakeSurvey?.clientGenderAtBirth,
  );
}

export function isClientMarriedOrPartnered(
  maritalStatus?: string,
  hasPartnerWithDemographics = false,
): boolean {
  return mapMaritalStatusToTraditionalLTC(maritalStatus) === 'Married' || hasPartnerWithDemographics;
}

export function calcClientDemographics(intakeSurvey: Partial<IntakeSurvey>) {
  const dateOfBirth = intakeSurvey.clientBirthDate ? new Date(intakeSurvey.clientBirthDate) : null;
  const age = dateOfBirth ? calculateAge(dateOfBirth) : 0;

  const clientTobaccoStatus = isTobacco(intakeSurvey) ? 'Tobacco' : 'Non-Tobacco';
  const gender = intakeSurvey.clientGenderAtBirth === 'Male' ? 'Male' : 'Female';
  const state = intakeSurvey.clientZipCode ? zipCodeToState(intakeSurvey.clientZipCode) : null;

  const demographics = {
    primaryAge: age,
    primaryGender: gender,
    primaryTobaccoStatus: clientTobaccoStatus,
    state,
    maritalClass: intakeSurvey.clientMaritalStatus
      ? mapMaritalStatusToTraditionalLTC(intakeSurvey.clientMaritalStatus)
      : null,
  };

  return demographics;
}
